<template>
  <div class="main admin-tests-edit">
      <div class="title-bar">
        <h1 class="mb-0">Test Results</h1>
        <a class="btn-back" :href="route('admin.tests.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a> 
      </div>

      <div class="row py-4 px-4 align-items-start">
          <div class="col-md-7">
            <div v-for="(response, count) in submission.responses" :key="response.id" class="mb-3 pr-md-4 pt-3">
                <h3 class="field">Question #{{count + 1}}</h3>  
                <div v-if="response.field">
                    <p class="field" v-html="response.field ? response.field.content : ''"></p>
                    <template v-if="response.field.type != fieldTypeMap.MATCHING_FIELD">
                        <div class="options" v-if="response.field.options">
                            <div class="option" v-for="(option, key) in response.field.options" :key="key">
                                {{option}}
                                <span class="correct" 
                                    v-if="key == response.field.answer && response.field.answer == response.value">
                                    &check;
                                </span>
                                <span class="incorrect"
                                    v-else-if="key == response.field.answer">
                                    &#10005;
                                </span> 
                            </div>
                        </div>
                    </template>
                    <template v-else-if="response.field.type == fieldTypeMap.MATCHING_FIELD">
                        <div class="options">
                            <div class="option" v-for="(match,question) in response.value" :key="question">
                                <span class="question">{{response.field.options.a[question]}}</span>
                                <span class="match font-weight-bold">{{response.field.options.b[match]}}</span>

                                <span class="correct" 
                                    v-if="response.field.answer[question] == match">
                                    &check;
                                </span>
                                <span class="incorrect" v-else>
                                    &#10005;
                                </span> 
                            </div>
                        </div>
                    </template>
                    <hr class="pb-2" />
                </div>
                <div v-else class="alert alert-danger">
                    It looks like this question was deleted or changed.
                </div>
            </div>
          </div>
          <div class="col-md-5 details-pane p-3">
              <h3>Submission Results</h3>
              <p class="submission-status">
                  <p class="user"><b>User:</b> {{submission.created_by.name}} </p>
                  <p class="score"><b>Score:</b> {{submission.score}} / {{submission.maxScore}} 
                    <span :class="getStatusClass(submission)">
                    ({{submission.statusLabel}}) 
                    </span>
                  </p>
                  <p class="required-store"><b>Required Score:</b> {{submission.minScore}}</p>
                  <p class="time"><b>Submitted On:</b> {{submission.created_at | moment("MM/DD/YYYY")}}</p>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import FieldEditor from "mixins/Forms/FieldEditor";

export default {
  mixins: [DisplaysAlerts], 
  components: { FieldEditor }, 
  props: {
    submission: { type: Object, required: true },
  },
  data() {
    return {
        fieldTypeMap: {}
    };
  },
  computed: {
      
  },
  methods: {
      getStatusClass(sub) {
          return 'status-' + sub.statusLabel.toLowerCase();
      }
  },
  watch: {
    //
  },
  mounted() {
      //
  },
  created() {
      this.fieldTypeMap = {
        CHECK_ALL_FIELD: "CheckAll",
        MATCHING_FIELD: "Matching",
        MULTIPLE_CHOICE_FIELD: "MultipleChoice",
        SEQUENCE_FIELD: "Sequence",
        TEXT_FIELD: "Text",
        TRUE_FALSE_FIELD: "TrueFalse"
    };
  }
};
</script>

<style scoped>
.correct, .status-passed {
    color: green;
}
.correct, .incorrect {
    font-weight: bolder;
}
.incorrect {
    color: red;
}
</style>